import API from "./api";
import { Gallery } from "./endpoints";

export const getAllGallery = (category = "all") => {
  const params = category && category !== "all" ? { category } : {};

  return API.get(`${Gallery}`, { params });
};
